import * as types from './actionTypes';
import * as serverErrorServices from 'services/apis/serverErrorServices';

/**
 * definizione delle action per le chiamate ajax
 */
export function beginAjaxCall(){
    return {type: types.BEGIN_AJAX_CALL}
}

/**
 * gestione errore http
 * @param {http error} error
 */
export function ajaxCallError(error){
    if(error && error.request && error.response)
    {
        serverErrorServices.handleOperationResponse(error.response).all().pipe();
    }
    else{
        throw error;
    }

    return {type: types.AJAX_CALL_ERROR}
}

/**
 * gestione errore http
 * @param {http error} error
 */
export function ajaxCallErrorButNotFound(error){
    if(error && error.request && error.response)
    {
        serverErrorServices.handleOperationResponseButNotFound(error.response).all().pipe();
    }
    else{
        throw error;
    }

    return {type: types.AJAX_CALL_ERROR}
}

/**
 * gli errori di login hanno una gestione differente
 * @param {login error} error
 */
export function ajaxSignInCallError(error){
    if(error && error.response)
    {
        serverErrorServices.handleSignInResponse(error.response).all().pipe();
    }

    return {type: types.AJAX_CALL_ERROR}
}


// WEBPACK FOOTER //
// ./src/actions/ajaxStatusActions.js